<!-- 投放助理数据 -->
<template>
	<div id="assistant">
		<!-- 标题 -->
		<div class="page-title">投放助理数据</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
			<div class="screen-box">
				<div class="screen-label">投放日期</div>
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			<div class="screen-box">
				<div class="screen-label">投放助理</div>
				<a-select default-value="未选择" style="width: 160px" show-search allowClear
				 :filter-option="filterOption"
				 @change="handleChangeC" >
				 <a-select-option  value="0">
				 	未选择
				 </a-select-option>
					<a-select-option  v-for="(item,index) in pitcherList" :key="item.assistant_id" :value="item.assistant_id">
						{{item.name}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">投放作品</div>
				<!-- <a-select default-value="未选择" style="width: 200px" show-search allowClear
				 :filter-option="filterOption"
				 @change="handleChangeE" >
					 <a-select-option  value="0">
						未选择
					 </a-select-option>
					<a-select-option  v-for="(item,index) in filterList.book_id.list" :key="item.key" :value="item.key">
						{{item.value}}
					</a-select-option>
				</a-select> -->
				<putBookS ref="getPutBookS_S" :s_width="'280px'" :select_type="'assistant'" @handleChangeSelect="handleChangeE"></putBookS>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">媒体渠道</div>
				<a-select default-value="未选择" style="width: 160px" show-search allowClear
				 :filter-option="filterOption"
				 @change="handleChangeD" >
					<a-select-option  value="0">
						未选择
					</a-select-option>
					<a-select-option  v-for="(item,index) in filterList.media_id.list" :key="item.key" :value="item.key">
						{{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			
			
			<div class="screen-box">
				<div class="screen-label">投手</div>
				<a-select default-value="未选择" style="width: 160px" show-search allowClear
				 :filter-option="filterOption"
				 @change="handleChangeF" >
					 <a-select-option  value="0">
						未选择
					 </a-select-option>
					<!-- <a-select-option  v-for="(item,index) in filterList.op_id.list" :key="item.key" :value="item.key">
						{{item.value}}
					</a-select-option> -->
					
					<!-- 此投手为创意策划获取的投手 -->
					<a-select-option  v-for="(value,key) in cych_Select" :key="key" :value="key">
						{{value}}
					</a-select-option>
				</a-select>
			</div>
			
		</div>
		
		<div style="margin-top: 5px;margin-bottom: 15px;">
			<a-button @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			<a-button @click="exportButton" type="primary" icon="download"  style="margin-right: 20px;">导出</a-button>
			<a-button @click="addListButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">+ 新增</a-button>
		</div>
		
		<!-- 表格内容 -->
		<TableAssistant @editDrawerButton="editDrawerButton" @delDrawerButton="delDrawerButton" :rableTitle="rableTitle" :tableShowData="tableShowData" :tableTotalData="tableTotalData" :table_scroll_width="table_scroll_width"></TableAssistant>
		<!-- 分页 -->
		<div style="text-align: center;margin-top: 30px;">
			<a-pagination v-model="r_cur_page" :pageSize="r_per_page" :total="table_total" @change="paginationChange" />
		</div>
		
		<!-- 新增和编辑的侧边栏 -->
		<a-drawer
		      :title="drawer_title"
			  width="600px"
		      placement="right"
		      :closable="false"
		      :visible="visible"
		      @close="onClose"
		    >
				<div style="padding: 10px;">
					<div class="form-cell-box">
						<div class="class-title">投放日期</div>
							
						<a-date-picker :value="moment(x_put_date, 'YYYY-MM-DD')" style="width:340px" @change="onAddChange" :allowClear="false" placeholder="选择投放日期" />
					</div>
					
					<div class="form-cell-box" >
						<div class="class-title" >投放助理</div>
							<a-select :value="x_toushou_assistant_id" 
							 style="width: 340px" 
							 placeholder="未选择"
							 @change="handleChangeG" 
							 :filter-option="filterOption" 
							 showSearch 
							 >
								<a-select-option  v-for="(item,index) in pitcherList" :key="item.assistant_id" :value="item.assistant_id">
									{{item.name}}
								</a-select-option>
							</a-select>
					</div>
					
					<div class="form-cell-box">
						<div class="class-title">投放作品</div>
							<!-- <a-select :value="x_book_id" 
							 placeholder="未选择" 
							 style="width: 340px"
							 @change="handleChangeI" 
							 :filter-option="filterOption"
							 showSearch 
							 >
								<a-select-option  v-for="(item,index) in filterList.book_id.list" :key="item.key" :value="item.key">
									{{item.value}}
								</a-select-option>
							</a-select> -->
							
							<putBookS ref="getPutBookS" @handleChangeSelect="handleChangeI"></putBookS>
					</div>
					
					<div class="form-cell-box">
						<div class="class-title">投放渠道</div>
							<a-select :value="x_media_id" 
							 placeholder="未选择" 
							 style="width: 340px"
							 @change="handleChangeH" 
							 :filter-option="filterOption"
							 showSearch 
							 >
								<a-select-option  v-for="(item,index) in filterList.media_id.list" :key="item.key" :value="item.key">
									{{item.value}}
								</a-select-option>
							</a-select>
					</div>
					
					
					<div class="form-cell-box">
						<!-- 此投手为创意策划获取的投手 -->
						<div class="class-title">投手</div>
							<a-select :value="x_toushou_id" 
							 placeholder="未选择" 
							 style="width: 340px"
							 @change="handleChangeJ" 
							 :filter-option="filterOption"
							 showSearch 
							 >
								<a-select-option  v-for="(value,key) in cych_Select" :key="key" :value="key">
									{{value}}
								</a-select-option>
							</a-select>
					</div>
					
					
					
					<div class="form-cell-box">
						<div class="class-title">投放金额</div>
							
						<a-input v-model="x_input_money" placeholder="请输入" type="number" style="width: 340px;" prefix="￥" suffix="RMB" />
					</div>
					
					<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
					
					<div class="form-cell-box" style="margin-top: 30px;">
						<a-button v-show='drawer_title === "新增"' @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
						<a-button v-show='drawer_title === "编辑"' @click="editRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
						<a-button @click="onClose">取消</a-button>
					</div>
				</div>
		</a-drawer>
		
		
		<!-- 加载中 -->
		<div class="loading-box" v-show="search_button_loading">
			<a-spin size="large" />
		</div>
	</div>
</template>

<script>
// import axios from 'axios'
	
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { assistantList, assistantMenu, assistantTableList,assistantAddList,assistantEditList,assistantDelList, assistantExport, assistantPutUser } from '@/request/api'
import TableAssistant from '@/components/putDataTable/TableAssistant.vue'
import putBookS from './components/putBookS.vue'
export default {
	name: 'assistant_',
	components: {
		TableAssistant, putBookS
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01',
			endTime: '2022-06-30',
			
			search_button_loading: false, // 搜索按钮的加载状态
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"投放日期",width:120, type:"put_date",sort_:90,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投放助理",width:130, type:"assistant_name",sort_:89,},
				{title:"投放渠道",width:160, type:"media_name",sort_:88,},
				{title:"投放作品",width:160, type:"book_name",sort_:87,},
				{title:"投放金额(元)",width:180, type:"put_money_format",sort_:86,},
				{title:"净投放金额(元)",width:180, type:"put_money_net_format",sort_:85,},
				{title:"投手",width:130, type:"toushou_name",sort_:84,},
				{title:"操作",width:180, type:"cao_zuo",sort_:83,},
			],
			tableShowData: [],
			tableTotalData: [],
			visible: false, // 侧边栏的控制，里面有新增和编辑的功能
			drawer_title: "操作", // 侧边栏的标题，新增/编辑
			pitcherList: [], // 投放助理
			filterList: {
				media_id:{},
				book_id:{},
				op_id:{}
			}, // 存筛选条件的数组
			r_media_id: 0, // 媒体渠道
			r_book_id: 0, // 投放书籍
			r_toushou_assistant_id: 0, // 投放助理
			r_toushou_id: 0, // 投手
			zz_string: ['put_date','assistant_name','media_name','book_name','put_money_format','put_money_net_format','toushou_name',], // 用于匹配/过滤
			table_scroll_width: 1090, // 表格宽度
			x_media_id: '', // 媒体渠道-新增/编辑版
			x_book_id: '', // 投放书籍-新增/编辑版
			x_toushou_assistant_id: undefined, // 投放助理-新增/编辑版
			x_toushou_id: "", // 投手-新增/编辑版
			x_put_date: "", // 投放日期
			x_input_money: "", // 投放金额
			x_edit_id: "", // 编辑用的id
			add_form_hint: "", // 表单验证提示
			add_button_loading: false,
			searchListData: [], // 页面表格的数据
			// 用于编辑的默认值
			default_put_date: '', // 投放日期
			r_cur_page: 1, // 页数
			r_per_page: 100, // 每页多少条
			table_total: 0, // 表格内容总数
			
			cych_Select: [], // 创意策划获取投手
		}
	},
	mounted(){
		let that = this
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		that.startTime = that.dateFormatHandle(
			new Date(new Date().getTime() - 1000*60*60*24 * 30),

		)
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + date2.getDate();
		
		that.x_put_date = that.endTime 
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.table_scroll_width = table_info.table_width
		
		// 获取投放助理
		assistantList().then(res=>{
			console.log('获取投放助理',res.data.data)
			that.pitcherList = res.data.data
		})
		
		assistantPutUser().then(res=>{
			console.log("创意策划获取投手",res);
			that.cych_Select = res.data.data.list || []
		})
		
		that.search_button_loading = true
		// 获取搜索条件
		assistantMenu().then(res=>{
			console.log('获取搜索条件',res.data.data)
			that.filterList = res.data.data.filter
			that.$nextTick(()=>{
				that.$refs.getPutBookS_S.getSelectData(that.filterList.book_id.list || [])
			})
			
			that.searchButton()
		})
	},
	methods:{
		dateFormatHandle (date, fmt = 'yyyy-MM-dd') {
			function padLeftZero(str) {
				return `00${str}`.substr(str.length);
			}
			if (/(y+)/.test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1,
					`${date.getFullYear()}`.substr(4 - RegExp.$1.length)
				);
			}
			const o = {
				'M+': date.getMonth() + 1,
				'd+': date.getDate(),
				'h+': date.getHours(),
				'm+': date.getMinutes(),
				's+': date.getSeconds(),
			};
			for (const k in o) {
				if (new RegExp(`(${k})`).test(fmt)) {
					const str = `${o[k]}`;
					fmt = fmt.replace(
						RegExp.$1,
						RegExp.$1.length === 1 ? str : padLeftZero(str)
					);
				}
			}
			return fmt;
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 选择框内的搜索
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投放助理
		handleChangeC(value) {
			this.r_toushou_assistant_id = value
		    console.log(`selected ${value}`);
		},
		// 媒体渠道
		handleChangeD(value) {
			this.r_media_id = value
		    console.log(`selected ${value}`);
		},
		// 投放书籍
		handleChangeE(value) {
			this.r_book_id = value
		    console.log(`selected ${value}`);
		},
		// 投手
		handleChangeF(value) {
			this.r_toushou_id = value
		    console.log(`selected ${value}`);
		},
		
		// 投放助理-新增/编辑版
		handleChangeG(value){
			this.x_toushou_assistant_id = value
		},
		// 媒体渠道-新增/编辑版
		handleChangeH(value) {
			this.x_media_id = value
		    console.log(`selected ${value}`);
		},
		// 投放书籍-新增/编辑版
		handleChangeI(value) {
			this.x_book_id = value
		    console.log(`selected ${value}`);
		},
		// 投手-新增/编辑版
		handleChangeJ(value) {
			this.x_toushou_id = value
		    console.log(`selected ${value}`);
		},
		
		
		// 侧边栏选择
		onClose() {
			if(this.add_button_loading){ // 新增中或编辑中不准关闭侧边栏
				return
			}
		    this.visible = false;
			let that = this
			that.x_media_id = null, // 媒体渠道-新增/编辑版
			that.x_book_id = null, // 投放书籍-新增/编辑版
			that.x_toushou_assistant_id = null, // 投放助理-新增/编辑版
			that.x_toushou_id = null // 投手-新增/编辑版
			that.x_put_date = that.endTime
			
			that.$nextTick(()=>{
				that.$refs.getPutBookS.getClose()
			})
		},
		
		// 新增
		addListButton(){
			let that = this
			that.add_form_hint = ''
			
			that.x_media_id = undefined, // 媒体渠道-新增/编辑版
			that.x_book_id = '', // 投放书籍-新增/编辑版
			that.x_toushou_assistant_id = undefined, // 投放助理-新增/编辑版
			that.x_toushou_id = undefined, // 投手-新增/编辑版
			that.x_input_money = '' // 输入金额
			
			this.visible = true
			this.drawer_title = "新增"
			
			that.$nextTick(()=>{
				that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
			})
		},
		// 新增/编辑的选择日期
		onAddChange(date, dateString) {
		    console.log(date, dateString);
			this.x_put_date = dateString
		},
		// 编辑按钮
		editDrawerButton(index){
			let that = this
			console.log("编辑",that.searchListData[index])
			// console.log("编辑put_book",that.searchListData[index].put_book)
			// console.log("编辑toushou_assistant_id",that.searchListData[index].toushou_assistant_id)
			// console.log("编辑.toushou_id",that.searchListData[index].toushou_id)
			// console.log("编辑put_date",that.searchListData[index].put_date)
			// console.log("编辑put_money_format",that.searchListData[index].put_money_format)
			
			that.add_form_hint = ''
			
			// 给请求接口赋值默认值
			that.x_put_date = that.searchListData[index].put_date, // 投放日期
			that.x_media_id = that.searchListData[index].media_id, // 媒体渠道-新增/编辑版
			that.x_book_id = that.searchListData[index].put_book, // 投放书籍-新增/编辑版
			that.x_toushou_assistant_id = that.searchListData[index].toushou_assistant_id, // 投放助理-新增/编辑版
			that.x_toushou_id = that.searchListData[index].toushou_id, // 投手-新增/编辑版
			that.x_input_money = that.searchListData[index].put_money_format.replace(/,/g, ''), // 投放金额
			that.x_edit_id = that.searchListData[index].id
			
			this.visible = true
			this.drawer_title = "编辑"
			
			that.$nextTick(()=>{
				that.$refs.getPutBookS.getSelectData(that.filterList.book_id.list || [])
				that.$refs.getPutBookS.getEdit(that.x_book_id)
			})
		},
		// 删除按钮
		delDrawerButton(index){
			let that = this
			console.log("编辑",that.searchListData[index])
			this.$confirm({
				title: '警告',
				content: '确定要删除该内容吗',
				okText: '删除',
				okType: 'danger',
				cancelText: '取消',
				onOk() {
				  assistantDelList({id: that.searchListData[index].id}).then(res=>{
				  	console.log("删除",res)
				  	if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
				  		that.$message.success('删除成功');
				  		that.searchButton()
				  	}
				  })
				},
				onCancel() {
				  console.log('Cancel');
				},
			});
			
		},
		
		// 搜索按钮
		searchButton(type){
			let that = this
			if(!that.startTime || !that.endTime){
				this.$warning({
					title: '警告',
					content: '请选择日期范围',
				});
				return
			}
			
			this.search_button_loading = true
			
			if(type == 'button'){
				that.r_cur_page = 1
			}
			
			console.log("that.startTime",that.startTime)
			console.log("that.endTime",that.endTime)
			let r_data = {
				start_date: that.startTime,
				end_date: that.endTime,
				
				media_id: that.r_media_id,
				book_id: that.r_book_id,
				toushou_assistant_id: that.r_toushou_assistant_id,
				toushou_id: that.r_toushou_id,
				
				page: that.r_cur_page,
				limit: that.r_per_page,
				excel_type: 0,
			}
			console.log("r_data",r_data)
			
			if(type != '导出'){
				assistantTableList(r_data).then(res=>{
					console.log("搜搜结果",res.data.data)
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						if(res.data.data.length < 1){ // 内容为空
							that.tableShowData = []
							that.tableTotalData = []
							that.search_button_loading = false
							that.$message.success('搜索成功');
							return
						}
						that.table_total = res.data.data.total || 0
						// 深拷贝
						let req_data = JSON.parse(JSON.stringify(res.data.data || []))
						that.searchListData = req_data.data || [] // 保存一份，编辑要用
						// 把返回来的数据处理成表格上展现的。加上排序，宽度，内容等信息
						function handleData(sum_data){
							let total_key = Object.keys(sum_data)
							// console.log("total_key",total_key)
							let total_arry = []
							total_key.forEach((res,index) => {
								
								if(that.zz_string.indexOf(res) > -1){ // 过滤，只放表格需要的内容
									let obj = {
										value: sum_data[res],
										keys: res,
									}
									
									that.rableTitle.forEach((res_z,index_z) =>{
										if(res === res_z.type){
											obj.widths = res_z.width // 加上宽度
											obj.sort_ = res_z.sort_ // 加上排序值，用来排序
											// obj.show_control = res_z.show_control // 控制单元格是否显示
										}
									})
									total_arry.push(obj)
								}
							})
							
							return total_arry
						}
						
						// 总计那一行的处理
						let z_data = req_data.sumData
						if(!z_data.hasOwnProperty('put_date')){
							z_data.put_date = " "
						}
						if(!z_data.hasOwnProperty('assistant_name')){
							z_data.assistant_name = " "
						}
						if(!z_data.hasOwnProperty('media_name')){
							z_data.media_name = " "
						}
						if(!z_data.hasOwnProperty('book_name')){
							z_data.book_name = " "
						}
						if(!z_data.hasOwnProperty('put_money_format')){
							z_data.put_money_format = " "
						}
						if(!z_data.hasOwnProperty('put_money_net')){
							z_data.put_money_net = " "
						}
						if(!z_data.hasOwnProperty('toushou_name')){
							z_data.toushou_name = " "
						}
						
						let total_arry = handleData(z_data)
						console.log("total_arry",total_arry)
						total_arry.sort((a,b)=>{ // 从大到小排序
							return b.sort_ - a.sort_
						})
						console.log("total_arry",total_arry)
						that.tableTotalData = total_arry
						
						// 表格内容处理开始
						let show_data = req_data.data
						let show_arry = []
						
						show_data.forEach((res,index)=>{
							let s_data = handleData(res).sort((a,b)=>{ // 从大到小排序
								return b.sort_ - a.sort_
							})
							
							show_arry.push(s_data)
						})
						console.log("show_arry",show_arry)
						that.tableShowData = show_arry || []
						
						// 根据展示内容的不同，要对内容宽度进行处理
						let nnn = 0 // 边距
						that.rableTitle.forEach((res,index)=>{
							
								nnn += res.width
							
						})
						that.table_scroll_width = nnn 
						
						that.search_button_loading = false
						that.$message.success('搜索成功');
					}
					else {
						that.search_button_loading = false
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
				})
				.catch(err=>{
					this.$message.error('搜索请求错误，可能是网络不佳');
					that.search_button_loading = false
				})
			}
			else if(type == '导出'){
				r_data.excel_type = 1
				delete r_data.page
				delete r_data.limit
				assistantExport(r_data).then(res=>{
					console.log("导出测试",res);
					that.search_button_loading = false
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){ 
						
						that.$message.success(res.data.msg || "导出成功");
						
					}
					else {
						
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
						
					}
				})
			}
		},
		// 导出
		exportButton(){
			let that = this
			
			// let r_data = {
			// 	start_date: that.startTime,
			// 	end_date: that.endTime,
				
			// 	media_id: that.r_media_id || '0',
			// 	book_id: that.r_book_id || '0',
			// 	toushou_assistant_id: that.r_toushou_assistant_id || '0',
			// 	toushou_id: that.r_toushou_id || '0',
				
			// 	excel_type: '1',
			// }
			// console.log('this.axios',this.$http.excel_url)
			// let r_url = `${that.$http.excel_url}api/down/assistant-stats-report?start_date=${that.startTime}&end_date=${that.endTime}&media_id=${that.r_media_id}&book_id=${that.r_book_id}&toushou_assistant_id=${that.r_toushou_assistant_id}&toushou_id=${that.r_toushou_assistant_id}&excel_type=1`
			// console.log('r_url',r_url)
			
			// window.open(r_url);
			
			that.searchButton('导出')
			
			
		},
		
		
		
		addRequest(){
			let that = this
			console.log(that.x_input_money.length === 0)
			if(!that.x_put_date){ // 没有投放日期
				that.add_form_hint = "请填写 投放日期 ！！！"
			}
			else if(!that.x_toushou_assistant_id){ // 没有投放助理
				that.add_form_hint = "请填写 投放助理 ！！！"
			}
			else if(!that.x_book_id){ // 投放书籍-新增/编辑版
				that.add_form_hint = "请填写 投放作品 ！！！"
			}
			else if(!that.x_media_id){ // 媒体渠道-新增/编辑版
				that.add_form_hint = "请填写 媒体渠道 ！！！"
			}
			else if(!that.x_toushou_id){ // 投手-新增/编辑版
				that.add_form_hint = "请填写 投手 ！！！"
			}
			else if(that.x_input_money.length === 0){ // 投放金额-新增/编辑版
				that.add_form_hint = "请填写 投放金额 ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				
				let r_data = {
					put_date: that.x_put_date, // 投放日期
					assistant_id: that.x_toushou_assistant_id, // 投放助理-新增/编辑版
					book_id: that.x_book_id, // 投放书籍-新增/编辑版
					media_id: that.x_media_id, // 媒体渠道-新增/编辑版
					toushou_id: that.x_toushou_id, // 投手-新增/编辑版
					put_money: that.x_input_money, // 金额-新增/编辑版
				}
				console.log('r_data',r_data)
				assistantAddList(r_data).then(res=>{
					console.log("新增/編輯返回值",res)
					that.add_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						
						that.$message.success('新增成功');
						
						that.visible = false
						
						that.x_media_id = '' // 媒体渠道-新增/编辑版
						that.x_book_id = '' // 投放书籍-新增/编辑版
						that.x_toushou_assistant_id = '' // 投放助理-新增/编辑版
						that.x_toushou_id = "" // 投手-新增/编辑版
						that.x_put_date = "" // 投放日期
						that.x_input_money = "" // 投放金额
						
						that.searchButton()
					}
				})
				.catch(err=>{
					that.$message.error('新增失败，可能是网络不佳');
					that.add_button_loading = false
				})
			}
			
			
		},
		// 编辑的确认按钮
		editRequest(){
			let that = this
			if(!that.x_put_date){ // 没有投放日期
				that.add_form_hint = "请填写 投放日期 ！！！"
			}
			else if(!that.x_toushou_assistant_id){ // 没有投放助理
				that.add_form_hint = "请填写 投放助理 ！！！"
			}
			else if(!that.x_book_id){ // 投放书籍-新增/编辑版
				that.add_form_hint = "请填写 投放作品 ！！！"
			}
			else if(!that.x_media_id){ // 媒体渠道-新增/编辑版
				that.add_form_hint = "请填写 媒体渠道 ！！！"
			}
			else if(!that.x_toushou_id){ // 投手-新增/编辑版
				that.add_form_hint = "请填写 投手 ！！！"
			}
			else if(that.x_input_money.length === 0){ // 投放金额-新增/编辑版
				that.add_form_hint = "请填写 投放金额 ！！！"
			}
			else {
				that.add_form_hint = ""
				that.add_button_loading = true
				console.log("编辑")
				let r_data = {
					put_date: that.x_put_date, // 投放日期
					assistant_id: that.x_toushou_assistant_id, // 投放助理-新增/编辑版
					book_id: that.x_book_id, // 投放书籍-新增/编辑版
					media_id: that.x_media_id, // 媒体渠道-新增/编辑版
					toushou_id: that.x_toushou_id, // 投手-新增/编辑版
					put_money: that.x_input_money, // 金额-新增/编辑版
					id: that.x_edit_id // id
				}
				console.log('r_data',r_data)
				assistantEditList(r_data).then(res=>{
					console.log(res)
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('编辑成功');
						
						that.visible = false
						that.add_button_loading = false
						that.searchButton()
					}
					else{
						this.$message.error(res.data.msg);
						that.add_button_loading = false
					}
				})
			}
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_cur_page = e
			this.searchButton()
		}
	}
}
</script>

<style scoped>

</style>